import React from "react";

type AnnouncementBarProps = {
  onClick: () => void;
};

const AnnouncementBar = ({ onClick }: AnnouncementBarProps) => {
  return (
    <div
      className="w-full bg-black/40 border-b border-white/10 text-white cursor-pointer"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <div className="container mx-auto px-3 py-2 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div className="text-sm">
          <strong>Something New Is Coming!</strong> The 2025 SooKee Rewards Program has ended — stay tuned for updates.
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
